export const BLOB_URL = 'https://vjty48mcawai4hpu.public.blob.vercel-storage.com/assets';

/**
 * Helper function to get the full blob asset URL from a relative path
 * @param path - Relative path to the asset (e.g., 'favicon/favicon.ico')
 * @returns Full blob URL to the asset
 */
export const getBlobUrl = (path: string): string => `${BLOB_URL}/${path}`;

export default {
	getBlobUrl,
	BLOB_URL,
};

